enum ProductTypes {
  "dynamic" = "dynamic",
  "static" = "static",
  "external" = "external",
}

export default ProductTypes;
